<template>
    <div class="containerInner">
        <div class="dispType">
            <div class="roasDefault" :class="{ 'roasDefaultItem': this.defaultMenu == 'productAndMall' }"
                @click.stop="toggleDefault('productAndMall')">
                {{ this.defaultMenu == 'productAndMall' ? '★' : '☆' }}
            </div>
            <div class="typeItem" @click="selectTotallingMenu(totallingMenus.productAndMall)">
                <div :class="[this.selectedTotallingMenu == this.totallingMenus.productAndMall ? 'onDisp' : 'offDisp']">
                    表示中
                </div>
                <div class="totallingMenu">自社･モール合計</div>
            </div>
            <div class="roasDefault" :class="{ 'roasDefaultItem': this.defaultMenu == 'site' }"
                @click.stop="toggleDefault('site')">
                {{ this.defaultMenu == 'site' ? '★' : '☆' }}
            </div>
            <div class="typeItem" @click="selectTotallingMenu(totallingMenus.site)">
                <div :class="[this.selectedTotallingMenu == this.totallingMenus.site ? 'onDisp' : 'offDisp']">表示中</div>
                <div class="totallingMenu">サイト合計</div>
            </div>
        </div>

        <div class="dataControllLeft sp">
            <div class="tooltipsHover ml20">
                <Icon>clock</Icon>
                <span class="tooltips">
                    最終更新日時<br>
                    {{ lastUpdate['yesterday'] }}
                </span>
            </div>
            <a v-if="this.$store.state.isAccessableDev" class="btn" @click="showDataUpdate">データ更新</a>
        </div>

        <div class="dispMenu">
            <div class="dispLeftMenu">
                <span class="dispDateUnit">
                    <PochiRadioToggleButtons v-model="dateUnit" :values="dateUnitList" small text-color="#fff" />
                </span>
                <span class="dispPeriod">
                    <datepicker :minimumView="minView(this.dateUnit)" :maximumView="maxView(this.dateUnit)"
                        :format="datepickerFormat" :language="ja" calendar-class="calendarDate" input-class="inputDate"
                        wrapper-class="dispPeriodInput" placeholder="開始日" v-model="datepickerStartDate"
                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                    <span>〜</span>
                    <datepicker :minimumView="minView(this.dateUnit)" :maximumView="maxView(this.dateUnit)"
                        :format="datepickerFormat" :language="ja" calendar-class="calendarDate" input-class="inputDate"
                        wrapper-class="dispPeriodInput" placeholder="終了日" v-model="datepickerStopDate"
                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                        :disabled-dates="{ to: datepickerStartDate }" />
                </span>
                <span>
                    <a class="btn borderNone applyBtn" @click="updateTable">適用</a>
                </span>
            </div>
            <div class="dispRightMenu">
                <span class="dispSettings">
                    <span class="dispSettingItem2">メルマガ・LINE</span>
                    <span class="dispSettingItemRadio2">
                        <toggle-button v-model="isExclusion_roas" :sync="true"
                            :color="{ checked: '#02adff', unchecked: '#02AD90' }" :height="30" :width="70"
                            :labels="{ checked: '除外', unchecked: '含む' }"></toggle-button>
                    </span>
                </span>
                <span class="dispAdMenu mr" @click="showSelectProduct">
                    <span class="productName">{{ selectedTargetName }}</span>
                </span>
                <template v-if="this.selectedTotallingMenu == this.totallingMenus.productAndMall">
                    <span class="dispAdMenu2" @click="showSelectService">
                        <span class="productName">{{ selectedServiceName }}</span>
                    </span>
                </template>
            </div>
        </div>
        <div class="dispMenu">
            <div class="dispRightMenu">
                <span class="dispSettingMenu">
                    <span class="dispSettingItem sp">表示日数</span>
                    <span class="dispSettingItemSelect">
                        <v-select name="hoge" :options="periodOptions" v-model="period"
                            :reduce="option => option.period"></v-select>
                    </span>
                    <span class="dispSettingItem sp">集計Base</span>
                    <span class="dispSettingItemRadio">
                        <toggle-button v-model="isSaleShipmentDateBased" :sync="true"
                            :color="{ checked: '#02adff', unchecked: '#02AD90' }" :height="30" :width="70"
                            :labels="{ checked: '出荷日', unchecked: '注文日' }"></toggle-button>
                    </span>
                    <span class="dispSettingItem sp">表示順序</span>
                    <span class="dispSettingItemRadio">
                        <toggle-button v-model="isOrderAsc" :sync="true"
                            :color="{ checked: '#02adff', unchecked: '#02AD90' }" :height="30" :width="60"
                            :labels="{ checked: '昇順', unchecked: '降順' }"></toggle-button>
                    </span>
                </span>
            </div>
        </div>

        <div class="dispMenu_white">
            <div class="dispLeftMenu">
                <div class="dataControllBtnLeft">
                    <a class="btn sp" @click="showColorSizeRoasPC">カラー・サイズ別</a>
                    <a class="btn pc" @click="showColorSizeRoasSP">カラー・サイズ別</a>
                    <div class="balloon sp" ref="balloon">
                        <a class="btn" @click="openBalloon">商品情報</a>
                        <div class="balloon_area">
                            <div class="input-balloon" v-show="isFocused">
                                <div class="balloon_flex">
                                    <p>商品情報</p>
                                    <span class="square_btn" @click="closeBalloon"></span>
                                </div>
                                <ProductDetailTable :productLists="this.productLists" :summaries="this.summaries"
                                    :show-costs="this.$store.state.isAccessable"
                                    :show-costs-dev="this.$store.state.isAccessableDev">
                                </ProductDetailTable>
                            </div>
                        </div>
                    </div>
                    <template v-if="this.selectedTarget.product.id != -1 || this.selectedTarget.type == 'totalling'">
                        <a class="btn sp" :href="getAmStockLink()" target="_blank">在庫確認</a>
                    </template>
                </div>
            </div>
            <div class="dispRightMenu sp">
                <div class="dataControllBtn">
                    <template v-if="this.selectedTotallingMenu == this.totallingMenus.productAndMall">
                        <a class="btn" @click="csvDownload">CSVダウンロード</a>
                    </template>
                    <template v-if="this.selectedTotallingMenu == this.totallingMenus.site">
                        <a class="btn" @click="csvDownloadSite">CSVダウンロード</a>
                    </template>
                    <a v-if="this.selectedTotallingMenu === this.totallingMenus.productAndMall
                        && this.dateUnit === 'day'
                        && this.selectedTarget.product.id <= 0
                        && this.selectedTarget.type !== 'totalling'" class="btn"
                        @click="$modal.show('inputOtherMediaCostAll')"
                        :class="{ 'notSelected': isLoading }">自社広告費手動入力</a>
                    <a v-if="this.selectedTotallingMenu === this.totallingMenus.productAndMall
                        && this.dateUnit === 'day'
                        && this.selectedTarget.product.id > 0
                        && this.selectedTarget.type !== 'totalling'" class="btn"
                        @click="$modal.show('inputOtherMediaCost')" :class="{ 'notSelected': isLoading }">自社広告費手動入力</a>
                    <a class="btn" @click="$modal.show('uploadRegularCsv')">自社広告CSVアップロード</a>
                    <a class="btn" @click="$modal.show('uploadCsv')">ECモール広告CSVアップロード</a>
                </div>
            </div>
        </div>


        <div class="dispLoading">
            <LoadingLinear v-if="isLoading" />
        </div>

        <!-- 自社・モール合計表 -->
        <div class="dispDataContents"
            v-if="selectedTotallingMenu === totallingMenus.productAndMall && isLoading === false">
            <ProductMallTable :is-order-asc="isOrderAsc" :performance-reports="performanceReports"
                :service-reports="serviceReports" :is-monthly="isMonthlyGrouped"
                :show-costs="this.$store.state.isAccessable" :dateUnit="dateUnit" :periodType="periodType" />
        </div>

        <!-- サイト合計表 -->
        <div class="dispDataContents" v-if="selectedTotallingMenu === totallingMenus.site && isLoading === false">
            <SiteTable :is-order-asc="isOrderAsc" :performance-reports="performanceReports"
                :is-monthly="isMonthlyGrouped" :dateUnit="dateUnit" :startDate="this.startDate.format('YYYY-MM-DD')"
                :endDate="this.stopDate" />
        </div>

        <!-- 商品選択モーダル -->
        <modal name="selectProduct" :draggable="false" :resizable="false" width="85%" height="80%">
            <ShowProduct modal-type="roasProduct" @modalClosed="selectProductModalClosed"
                v-model="inputSelectedTarget" />
        </modal>

        <!-- 店舗選択モーダル -->
        <modal name="selectService" :draggable="false" :resizable="false" width="65%" height="70%">
            <ShowService modal-type="roasService" @input="selectServiceId" @modalClosed="selectServiceModalClosed"
                v-model="inputSelectedService" :selectedService="this.selectedService" />
        </modal>

        <!-- 自社広告CSVアップロードモーダル -->
        <modal name="uploadRegularCsv" :draggable="false" :resizable="false" :clickToClose="false" width="700px"
            height="auto">
            <RoasProductUploadRegularCsv @uploaded="fetchProductData" @modalClosed="hideModalUploadRegularCsv" />
        </modal>

        <!-- ECモール広告CSVアップロードモーダル -->
        <modal name="uploadCsv" :draggable="false" :resizable="false" :clickToClose="false" width="700px" height="auto">
            <RoasProductUploadCsv @uploaded="fetchProductData" @modalClosed="hideModalUploadCsv" />
        </modal>

        <!-- 自社広告費手動入力モーダル（全商品） -->
        <modal name="inputOtherMediaCostAll" :draggable="false" :resizable="false" :clickToClose="false" width="85%"
            height="80%">
            <InputOtherMediaCostAll @postInputMediaCosts="fetchProductData" :productDatas="productDatas"
                @modalClosed="hideModalInputOtherMediaCostAll" />
        </modal>

        <!-- 自社広告費手動入力モーダル（単品） -->
        <modal name="inputOtherMediaCost" :draggable="false" :resizable="false" :clickToClose="false" width="85%"
            height="80%">
            <InputOtherMediaCost @postInputMediaCosts="fetchProductData" :productDatas="productDatas"
                @modalClosed="hideModalInputOtherMediaCost" />
        </modal>

        <!-- カラー・サイズ別ROAS表示用モーダル（PC用） -->
        <modal name="colorSizeRoasPC" :draggable="false" :resizable="false" width="50%" height="85%">
            <ColorSizeRoasModal :type="this.selectedTarget.type" :productId="this.selectedTarget.product.id"
                :totallingTargetId="this.selectedTarget.totallingTarget.id" :dateBase="this.isSaleShipmentDateBased"
                :startDate="this.startDate.format('YYYY-MM-DD')" :endDate="this.stopDate.format('YYYY-MM-DD')"
                :serviceId="this.selectedServiceIdList" @modalClosed="hideModalcolorSizeRoasPC" />
        </modal>

        <!-- カラー・サイズ別ROAS表示用モーダル（スマホ用） -->
        <modal name="colorSizeRoasSP" :draggable="false" :resizable="false" width="90%" height="85%">
            <ColorSizeRoasModal :type="this.selectedTarget.type" :productId="this.selectedTarget.product.id"
                :totallingTargetId="this.selectedTarget.totallingTarget.id" :dateBase="this.isSaleShipmentDateBased"
                :startDate="this.startDate.format('YYYY-MM-DD')" :endDate="this.stopDate.format('YYYY-MM-DD')"
                :serviceId="this.selectedServiceIdList" @modalClosed="hideModalcolorSizeRoasSP" />
        </modal>

        <!-- データ更新（日次バッチ手動実行）モーダル -->
        <modal name="dataUpdate" :draggable="false" :resizable="false" width="50%" height="560px">
            <div class="modal_dataUpdate">
                <div class="header">
                    <h3>データ更新（日次バッチ手動実行）</h3>
                </div>
                <div class="dataUpdate_period">
                    <span class="dataUpdate_periodLabel">対象期間</span>
                    <span class="dispPeriod">
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="開始日"
                            v-model="batchStartDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                            :disabled-dates="{ from: batchDisabledFrom }" />
                        <span>〜</span>
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="終了日"
                            v-model="batchEndDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                            :disabled-dates="{ to: batchStartDate, from: batchDisabledFrom }" />
                    </span>
                </div>
                <p class="dataUpdate_note">※更新には時間がかかる場合があります。</p>
                <div class="dataUpdate_btns">
                    <Button class="cancelBtn" @click="closeDataUpdate">キャンセル</Button>
                    <Button class="btn updateBtn" @click="executeDataUpdate">更新</Button>
                </div>
            </div>
        </modal>

        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductDetailTable from '../components/ProductDetail.vue'; //商品情報のテーブル部分
import ColorSizeRoasModal from '../components/ColorSizeRoasModal.vue'; //カラー・サイズ別ROAS表示用モーダル
import ProductMallTable from '../components/ProductMallTable.vue'
import SiteTable from '../components/SiteTable.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import ShowProduct from './ShowProduct.vue'
import ShowService from './ShowService.vue'
import RoasProductUploadCsv from './RoasProductUploadCsv.vue'
import RoasProductUploadRegularCsv from './RoasProductUploadRegularCsv'
import InputOtherMediaCost from './InputOtherMediaCost.vue'
import InputOtherMediaCostAll from './InputOtherMediaCostAll.vue'
import { saveAs } from 'file-saver'
import Encoding from 'encoding-japanese'
import _ from 'lodash';
// import groupBy from 'lodash/groupBy';

const DATE_UNIT_TYPE = {
    MONTH: 'month',
    WEEK: 'week',
    DAY: 'day',
};

const PERIOD_TYPE = {
    CLOSING: 'closing-month',
    WONDERFUL: 'wonderful-day',
    ZERO_FIVE: 'zero-five-day',
    MALL_EVENT: 'mall-event-day',
};

export default {
    components: {
        ProductDetailTable,
        ColorSizeRoasModal,
        ProductMallTable,
        SiteTable,
        Datepicker,
        ShowProduct,
        ShowService,
        RoasProductUploadCsv,
        RoasProductUploadRegularCsv,
        InputOtherMediaCost,
        InputOtherMediaCostAll,
    },
    data() {
        return {
            isFocused: false, //商品情報の吹き出し表示制御
            selectedTotallingMenu: this.$store.state.defaultMenu,
            totallingMenus: {
                productAndMall: 'productAndMall',
                site: 'site',
            },
            defaultMenu: this.$store.state.defaultMenu,
            dateUnit: DATE_UNIT_TYPE.DAY,
            isSaleShipmentDateBased: false,
            startDate: null,
            stopDate: null,
            ja: ja,
            modalShow: false,
            selectedTarget: {
                type: 'single',
                product: { id: -1, name: '全商品', },
                totallingTarget: { id: null, name: null, products: null },
            },
            selectedService: {
                id: -1,
                name: '全店'
            },
            selectedServiceIdList: [],
            isOrderAsc: false,
            isSettingMenuBottom: false,
            isLoading: true,
            incrementFetchProductData: 0,
            productDatas: {},
            isMonthlyGrouped: false,
            reports: {},
            productMallReports: {},
            siteReports: {},
            serviceReports: {},
            performanceReports: {},
            productLists: [], //商品情報の一覧「ProductDetailTable」に渡して表示する
            summaries: [],
            isExclusion_roas: false,
            periodType: null,
            linkFlg: false,
            link: "",
            lastUpdate: [],
            //データ更新（日次バッチ手動実行）の対象期間
            batchStartDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
            batchEndDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
        }
    },
    mounted: function () {
        // GETパラメータで表示条件を指定している場合
        const qStartDate = this.$route.query.startDate ?? null;
        const qStopDate = this.$route.query.stopDate ?? null;
        const qProductId = this.$route.query.productId ?? null;
        const qTargetId = this.$route.query.targetId ?? null;

        // 開始日
        if (qStartDate !== null) {
            this.startDate = this.$dayjs(qStartDate);
        }
        // 終了日
        if (qStopDate !== null) {
            this.stopDate = this.$dayjs(qStopDate);
        }
        // 単体商品ID
        if (qProductId !== null) {
            this.selectedTarget.type = "single";
            this.selectedTarget.product.id = qProductId;
        }
        // 商品グループID
        if (qTargetId !== null) {
            this.selectedTarget.type = "totalling";
            this.selectedTarget.totallingTarget.id = qTargetId;
        }

        this.$watch(
            function () {
                // fetchProductDataする監視対象
                // period はsetのときのみ動作させたいので除外
                return {
                    dateUnit: this.dateUnit,  // 日次・週次・月次
                    selectedTarget: this.selectedTarget, // 選択した対象
                    selectedService: this.selectedService,
                    selectedServiceIdList: [this.selectedService.id],
                    // selectedTotallingMenu:            this.selectedTotallingMenu, // 自社・モール別、サイト別
                    isSaleShipmentDateBased: this.isSaleShipmentDateBased, // 注文日・出荷日
                    // isOrderAsc:              this.isOrderAsc,
                    defaultMenu: this.defaultMenu, //デフォルト表示
                };
            },
            function () {
                //商品情報更新処理
                this.linkFlg = false;
                this.link = "";

                //自社・モール合計のみで表示するデータ
                if (this.selectedTotallingMenu == 'productAndMall') {
                    this.fetchServiceAdCosts();
                }

                this.fetchProductSummary();
                this.fetchProductDetail(this.selectedTarget.type, this.selectedTarget.product.id, this.selectedTarget.totallingTarget.id);
                this.fetchProductData();
            },
            { immediate: true }
        );
        //商品情報の吹き出し領域外をクリックした時閉じる処理
        document.addEventListener("click", this.handleClickOutside);

        this.getLastUpdate();
    },
    methods: {
        //商品情報の吹き出し表示
        openBalloon() {
            this.isFocused = true
        },

        //バツボタンをクリックした時、商品情報の吹き出し非表示（閉じる）
        closeBalloon() {
            this.isFocused = false
        },

        //商品情報の吹き出し領域外をクリックした時、商品情報の吹き出し非表示（閉じる）
        handleClickOutside(event) {
            if (this.isFocused && !this.$refs.balloon.contains(event.target)) {
                this.isFocused = false
            }
        },

        getLastUpdate() {
            this.axios.get('/api/lastSummaryUpdate')
                .then((res) => {
                    this.lastUpdate = res.data;
                }).catch(() => {
                }).finally(() => {
                })
        },

        showDataUpdate() {
            this.$modal.show('dataUpdate')
        },
        closeDataUpdate() {
            this.$modal.hide('dataUpdate')
        },
        executeDataUpdate() {
            const params = {
                start_day: this.$dayjs(this.batchStartDate).format('YYYY-MM-DD'),
                end_day: this.$dayjs(this.batchEndDate).format('YYYY-MM-DD'),
            };
            // 集計完了までローディング表示を出しておく（モーダルは完了後に閉じる）
            this.$store.dispatch("loading", true);
            this.axios.post('/api/summary/dailyBatch', params)
                .then(() => {
                    // 更新後のデータを再取得する
                    this.getLastUpdate();
                    this.updateTable();
                }).catch(() => {
                    alert('データ更新に失敗しました。');
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                    this.$modal.hide('dataUpdate')
                });
        },

        updateTable() {
            //自社・モール合計のみで表示するデータ
            if (this.selectedTotallingMenu == 'productAndMall') {
                this.fetchServiceAdCosts();
            }

            this.fetchProductData();
            this.fetchProductSummary();
        },

        //商品情報更新処理
        fetchProductDetail(type, product_id, totallingTarget_id) {
            let url = '';
            let target = '';

            if (type === "single") {
                if (product_id === -1) {
                    //全商品の商品情報取得
                    url = "/api/products/detail";
                }
                else {
                    //単一商品の商品情報取得
                    url = "/api/products/detail/single";
                    target = product_id;
                }
            }
            else {
                //グループ商品の商品情報取得
                url = "/api/products/detail/totalling";
                target = totallingTarget_id;
            }

            this.axios.get(url, {
                params: {
                    targetId: target,
                }
            })
                .then((res) => {
                    this.productLists = _.map(res.data, product => {
                        return product;
                    });
                });
        },

        //商品情報に載せる原価など取得
        fetchProductSummary() {
            var url = "/api/products/summary";
            const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
            const searchEndedAt = (this.stopDate < yesterday) ? this.stopDate : yesterday;
            var data = {
                start_date: this.startDate.format('YYYY-MM-DD'),
                end_date: searchEndedAt.format('YYYY-MM-DD'),
                is_exclusion_roas: this.isExclusion_roas,
            }
            this.axios.get(url, { params: data })
                .then((res) => {
                    this.summaries = [...res.data];
                }).catch(() => {
                }).finally(() => {
                });
        },

        //ROASテーブル更新処理
        fetchProductData() {
            this.isLoading = true;
            this.incrementFetchProductData++;
            const currentIncrementFetchProductData = this.incrementFetchProductData;
            let url = '';
            switch (this.selectedTotallingMenu) {
                case this.totallingMenus.productAndMall:
                    url = '/api/productRoasByOwnAndMall';
                    break;
                case this.totallingMenus.site:
                    url = '/api/productRoasBySites';
                    break;
            }
            const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
            const searchEndedAt = (this.stopDate < yesterday) ? this.stopDate : yesterday;
            this.isMonthlyGrouped = this.dateUnit === DATE_UNIT_TYPE.MONTH

            this.axios.get(url, {
                params: {
                    searchStartedAt: this.startDate.format('YYYY-MM-DD'),
                    searchEndedAt: searchEndedAt.format('YYYY-MM-DD'),
                    productId: this.selectedTarget.type == 'single' ? this.selectedTarget.product.id : null,
                    totallingTargetId: this.selectedTarget.type == 'totalling' ? this.selectedTarget.totallingTarget.id : null,
                    serviceId: this.selectedService.id,
                    order: 'asc',
                    isSaleShipmentDateBased: this.isSaleShipmentDateBased,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.dateUnit,
                    is_exclusion_roas: this.isExclusion_roas,
                    period_type: this.periodType
                }
            })
                .then((res) => {
                    if (currentIncrementFetchProductData != this.incrementFetchProductData) {
                        return;
                    }
                    switch (this.selectedTotallingMenu) {
                        case this.totallingMenus.productAndMall:
                            this.createProductAndMallReports(res.data);
                            break;
                        case this.totallingMenus.site:
                            this.createSiteReports(res.data);
                            break;
                    }
                    this.productDatas = res.data;
                    this.selectedTarget.product.name = this.productDatas.productName ?? null;
                    this.selectedTarget.totallingTarget.name = this.productDatas.totallingTarget?.name ?? null;
                    this.selectedTarget.totallingTarget.products = this.productDatas.totallingTarget?.products ?? null;
                }).catch(() => {
                }).finally(() => {
                    if (currentIncrementFetchProductData != this.incrementFetchProductData) {
                        return;
                    }
                    this.isLoading = false;
                })
        },

        //楽天広告のカテゴリ別取得
        fetchServiceAdCosts() {
            var url = "/api/service/adCosts";
            const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
            const searchEndedAt = (this.stopDate < yesterday) ? this.stopDate : yesterday;
            this.isMonthlyGrouped = this.dateUnit === DATE_UNIT_TYPE.MONTH
            var data = {
                start_date: this.startDate.format('YYYY-MM-DD'),
                end_date: searchEndedAt.format('YYYY-MM-DD'),
                dateUnit: this.dateUnit,
                service_id: this.selectedService.id,
                product_id: this.selectedTarget.type == 'single' ? this.selectedTarget.product.id : null,
                totalling_id: this.selectedTarget.type == 'totalling' ? this.selectedTarget.totallingTarget.id : null,
            }
            this.axios.get(url, { params: data })
                .then((res) => {
                    this.serviceReports = { ...res.data };
                    // for (var s of this.serviceReports) {
                    //     console.log(s);
                    // }
                }).catch(() => {
                }).finally(() => {
                });
        },
        createProductAndMallReports(data) {
            // // ProductMallTableコンポーネント必要ないプロパティを削除
            // this.$delete(data, 'productId');
            // this.$delete(data, 'productName');
            // this.$delete(data, 'searchStartedDate');
            // this.$delete(data, 'searchEndedDate');
            this.performanceReports = { ...data };
        },
        createSiteReports(data) {
            // // SiteTableコンポーネント必要ないプロパティを削除
            // this.$delete(data, 'productId');
            // this.$delete(data, 'productName');
            // this.$delete(data, 'searchStartedDate');
            // this.$delete(data, 'searchEndedDate');
            this.performanceReports = { ...data };
        },
        showSelectProduct() {
            this.modalShow = true
            this.$modal.show('selectProduct')
        },
        selectProductModalClosed() {
            this.modalShow = false
            this.$modal.hide('selectProduct')
        },
        showSelectService() {
            this.modalShow = true
            this.$modal.show('selectService')
        },
        selectServiceModalClosed() {
            this.modalShow = false
            this.$modal.hide('selectService')
        },
        selectServiceId(service) {
            this.selectedService.id = service.id
            this.selectedService.name = service.name

            this.selectedServiceIdList = [service.id]
        },
        showModalUploadCsv() {
            this.$modal.show('uploadCsv')
        },
        hideModalUploadRegularCsv() {
            this.$modal.hide('uploadRegularCsv')
        },
        hideModalUploadCsv() {
            this.$modal.hide('uploadCsv')
        },
        showModalInputOtherMediaCost() {
            this.$modal.show('inputOtherMediaCost')
        },
        hideModalInputOtherMediaCost() {
            this.$modal.hide('inputOtherMediaCost')
        },
        showModalInputOtherMediaCostAll() {
            this.$modal.show('inputOtherMediaCostAll')
        },
        hideModalInputOtherMediaCostAll() {
            this.$modal.hide('inputOtherMediaCostAll')
        },
        selectTotallingMenu(selectedTotallingMenu) {
            // 表示データ切替え(自社･モール別 or サイト別 or 費用分析)
            this.isLoading = true;
            this.selectedTotallingMenu = selectedTotallingMenu
            this.selectedService.id = -1
            this.selectedService.name = '全店'
            this.selectedServiceIdList = [];
            this.updateTable();
        },
        minView: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    return 'month';
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'day';
            }
            return null;
        },
        maxView: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'year';
            }
            return null;
        },
        //カラー・サイズ別ROASモーダル
        showColorSizeRoasPC() {
            this.$modal.show('colorSizeRoasPC')
        },
        showColorSizeRoasSP() {
            this.$modal.show('colorSizeRoasSP')
        },
        hideModalcolorSizeRoasPC() {
            this.$modal.hide('colorSizeRoasPC')
        },
        hideModalcolorSizeRoasSP() {
            this.$modal.hide('colorSizeRoasSP')
        },

        //CSVダウンロード
        csvDownload() {
            let url = '/api/productRoasByOwnAndMall/csv';

            let start_date = this.startDate.format('YYYY-MM-DD');
            let end_date = this.stopDate.format('YYYY-MM-DD');

            this.axios.get(url, {
                params: {
                    searchStartedAt: start_date,
                    searchEndedAt: end_date,
                    productId: this.selectedTarget.type == 'single' ? this.selectedTarget.product.id : null,
                    totallingTargetId: this.selectedTarget.type == 'totalling' ? this.selectedTarget.totallingTarget.id : null,
                    serviceId: this.selectedService.id,
                    order: 'asc',
                    isSaleShipmentDateBased: this.isSaleShipmentDateBased,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.dateUnit,
                    is_exclusion_roas: this.isExclusion_roas,
                    period_type: this.periodType,
                }
            })

                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // 商品名をファイル名に組み込む
                    var productname = "";
                    switch (this.selectedTarget.type) {
                        case 'single':
                            // 全商品のときは、商品IDが-1に設定されている
                            var id = "";
                            if (this.selectedTarget.product.id !== -1) {
                                id = '【' + this.selectedTarget.product.id + '】';
                            }
                            productname = id + this.selectedTarget.product.name;
                            break
                        case 'totalling':
                            var name = this.selectedTarget.totallingTarget.name ?? "";
                            var len = this.selectedTarget.totallingTarget.products?.length ?? 0;
                            productname = name + ` (${len}商品)`;
                            break;
                    }
                    // save
                    const fileName = productname + '(' + start_date + '～' + end_date + ').csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        csvDownloadSite() {
            let url = '/api/productRoasBySites/csv';

            let start_date = this.startDate.format('YYYY-MM-DD');
            let end_date = this.stopDate.format('YYYY-MM-DD');

            this.axios.get(url, {
                params: {
                    searchStartedAt: start_date,
                    searchEndedAt: end_date,
                    productId: this.selectedTarget.type == 'single' ? this.selectedTarget.product.id : null,
                    totallingTargetId: this.selectedTarget.type == 'totalling' ? this.selectedTarget.totallingTarget.id : null,
                    serviceId: this.selectedService.id,
                    order: 'asc',
                    isSaleShipmentDateBased: this.isSaleShipmentDateBased,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.dateUnit,
                    is_exclusion_roas: this.isExclusion_roas,
                    period_type: this.periodType,
                }
            })

                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // 商品名をファイル名に組み込む
                    var productname = "";
                    switch (this.selectedTarget.type) {
                        case 'single':
                            // 全商品のときは、商品IDが-1に設定されている
                            var id = "";
                            if (this.selectedTarget.product.id !== -1) {
                                id = '【' + this.selectedTarget.product.id + '】';
                            }
                            productname = id + this.selectedTarget.product.name;
                            break
                        case 'totalling':
                            var name = this.selectedTarget.totallingTarget.name ?? "";
                            var len = this.selectedTarget.totallingTarget.products?.length ?? 0;
                            productname = name + ` (${len}商品)`;
                            break;
                    }
                    // save
                    const fileName = 'サイト合計_' + productname + '(' + start_date + '～' + end_date + ').csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        updatePeriodType() {
            // ワンダフルデー・0と5のつく日
            const special_option = this.periodOptions.find(option => option.period === this.periodType)
            if (!special_option) {
                this.periodType = null;
            }
        },

        //ROASの初期表示
        toggleDefault(defaultName) {
            const data = {
                defaultName: defaultName,
            };
            this.axios.post("/api/toggleRoasDefault", data)
                .then(() => {
                    this.defaultMenu = defaultName;
                    this.selectTotallingMenu(defaultName);
                    this.$store.dispatch("defaultMenu", defaultName);
                });
        },
        //在庫確認リンク
        getAmStockLink() {
            if (!this.linkFlg) {
                var link = this.$helpers.am_url() + "/salesManagement";
                var query = "?pageLimit=100&gummiId=";
                var ids = [];
                // 商品グループをばらす
                if (this.selectedTarget.type == "totalling") {
                    if (this.selectedTarget.totallingTarget.products !== null) {
                        this.selectedTarget.totallingTarget.products.forEach(product => {
                            ids.push(product.id);
                        });
                    }
                }
                else {
                    ids.push(this.selectedTarget.product.id);
                }

                if (ids.length != 0) {
                    this.linkFlg = true;
                    for (var id of ids) {
                        query += id + ",";
                    }
                    // 末尾のカンマを取り除いて結合
                    link += query.substring(0, query.length - 1);
                    this.link = link;

                    return this.link;
                }
                return this.link;
            }
            return this.link;
        },
    },
    //商品情報の吹き出し領域外をクリックした時閉じる処理削除
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    watch: {

        //「日次・週次・月次」切り替え時の日付期間リセット処理
        dateUnit: {
            handler: function (dateUnit) {
                switch (dateUnit) {
                    case DATE_UNIT_TYPE.DAY:
                        this.startDate = this.$dayjs().startOf('date').subtract(7, 'days');
                        break;
                    case DATE_UNIT_TYPE.WEEK:
                        this.startDate = this.$dayjs().startOf('date').subtract(7, 'days');
                        break;
                    case DATE_UNIT_TYPE.MONTH:
                        // this.startDate = this.closingMonthStartDate;
                        this.startDate = this.$dayjs().startOf('month').subtract(12, 'month');
                        break;
                }
                this.stopDate = this.initStopDate;
            },
            immediate: true,
        },
        isExclusion_roas: {
            handler: function () {
                this.updateTable();
            }
        },
        //データ更新の開始日が終了日より後になった場合は終了日を合わせる
        batchStartDate: function (date) {
            if (date > this.batchEndDate) {
                this.batchEndDate = date;
            }
        },
    },
    computed: {
        //データ更新で選択できるのは前日まで
        batchDisabledFrom: function () {
            return this.$dayjs().startOf('date').subtract(1, 'day').toDate();
        },

        periodOptions: function () {
            let options = [];
            switch (this.dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    options = [
                        { label: '検索期間から選択', period: null },
                        { label: '1年間', period: 12 },
                        { label: '2年間', period: 24 },
                        { label: '決算月〜', period: PERIOD_TYPE.CLOSING },
                    ];
                    break;
                case DATE_UNIT_TYPE.WEEK:
                    options = [
                        { label: '検索期間から選択', period: null },
                        { label: '1週間', period: 7 },
                        { label: '2週間', period: 14 },
                        { label: '3週間', period: 21 },
                        { label: '4週間', period: 28 },
                        { label: '決算月〜', period: PERIOD_TYPE.CLOSING },
                    ];
                    break;
                case DATE_UNIT_TYPE.DAY:
                    options = [
                        { label: '検索期間から選択', period: null },
                        { label: '7日間', period: 7 },
                        { label: '14日間', period: 14 },
                        { label: '21日間', period: 21 },
                        { label: '30日間', period: 30 },
                        { label: '決算月〜', period: PERIOD_TYPE.CLOSING },
                    ];
                    break;
                default:
                    options = [];
            }
            // 楽天
            // ワンダフルデー（毎月1日）、0と5のつく日
            // 日次の場合「イベント」
            if (this.selectedService.name.includes("楽天")) {
                options.push(
                    { label: 'ワンダフルデー', period: PERIOD_TYPE.WONDERFUL },
                    { label: '0と5の付く日', period: PERIOD_TYPE.ZERO_FIVE },
                );
                if (this.dateUnit == DATE_UNIT_TYPE.DAY) {
                    options.push(
                        { label: 'イベント', period: PERIOD_TYPE.MALL_EVENT }
                    )
                }
            }
            // Yahoo
            // 日次の場合「イベント」
            if (this.selectedService.name.includes("Yahoo")) {
                if (this.dateUnit == DATE_UNIT_TYPE.DAY) {
                    options.push(
                        { label: 'イベント', period: PERIOD_TYPE.MALL_EVENT }
                    )
                }
            }
            // Amazon
            // 日次の場合「イベント」
            if (this.selectedService.name.includes("Amazon")) {
                if (this.dateUnit == DATE_UNIT_TYPE.DAY) {
                    options.push(
                        { label: 'イベント', period: PERIOD_TYPE.MALL_EVENT }
                    )
                }
            }
            // Wowma
            // 日次の場合「イベント」
            if (this.selectedService.name.includes("Wowma")) {
                if (this.dateUnit == DATE_UNIT_TYPE.DAY) {
                    options.push(
                        { label: 'イベント', period: PERIOD_TYPE.MALL_EVENT }
                    )
                }
            }
            return options;
        },
        //「表示日数」選択時
        period: {
            get: function () {
                this.updatePeriodType();
                if (!this.initStopDate.isSame(this.stopDate, this.dateUnit)) {
                    return null;
                }
                // ワンダフルデー・0と5のつく日
                const special_option = this.periodOptions.find(option => option.period === this.periodType)
                if (special_option) {
                    return special_option.period
                }

                var period = 0

                if (this.dateUnit == 'week') {
                    period = this.stopDate.diff(this.startDate, 'day') + 1;
                }
                else {
                    period = this.stopDate.diff(this.startDate, this.dateUnit)
                        + ((this.dateUnit == DATE_UNIT_TYPE.DAY) ? 1 : 0);
                }

                const option = this.periodOptions.find(option => option.period === period)
                if (option) {
                    return option.period
                }
                if (this.startDate.isSame(this.closingMonthStartDate, this.dateUnit)) {
                    return PERIOD_TYPE.CLOSING
                }


                return null
            },
            set: function (period) {
                if (!period) {
                    return
                }
                this.periodType = null;
                // 決算月
                if (period == PERIOD_TYPE.CLOSING) {
                    this.startDate = this.closingMonthStartDate;
                }
                // ワンダフルデー
                else if (period == PERIOD_TYPE.WONDERFUL) {
                    this.periodType = PERIOD_TYPE.WONDERFUL;
                    this.startDate = this.$dayjs().startOf('day').subtract(1, 'year');
                }
                // 0と5のつく日
                else if (period == PERIOD_TYPE.ZERO_FIVE) {
                    this.periodType = PERIOD_TYPE.ZERO_FIVE;
                    this.startDate = this.$dayjs().startOf('day').subtract(1, 'year');
                }
                // イベント
                else if (period == PERIOD_TYPE.MALL_EVENT) {
                    this.periodType = PERIOD_TYPE.MALL_EVENT;
                }
                //週次
                else if (this.dateUnit == 'week') {
                    this.startDate = this.$dayjs().startOf('day').subtract(period, 'day');
                }
                //日次・月次
                else {
                    this.startDate = this.$dayjs().startOf(this.dateUnit).subtract(period, this.dateUnit);
                }

                //「イベント」以外、終了日を基準日に戻す
                if (period != PERIOD_TYPE.MALL_EVENT) {
                    this.stopDate = this.initStopDate;
                }

                this.updateTable();
            },
        },
        closingMonthStartDate: function () {
            const now = this.$dayjs().startOf('date')
            // 12-01
            let start = now.month(11).startOf('months')
            const stop = now.subtract(1, 'days')
            // 12-01よりまえなら去年
            if (start.isAfter(stop)) {
                start = start.subtract(1, 'years')
            }
            return start;
        },
        initStopDate: function () {
            return this.$dayjs().endOf('day').subtract(1, 'days');
        },
        dateUnitList: function () {
            return [
                { label: '日次', value: DATE_UNIT_TYPE.DAY },
                { label: '週次', value: DATE_UNIT_TYPE.WEEK },
                { label: '月次', value: DATE_UNIT_TYPE.MONTH },
            ];
        },
        datepickerFormat: function () {
            switch (this.dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    return 'yyyy-MM';
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'yyyy-MM-dd';
            }
            return null;
        },



        //日付選択時の画面表示日付の設定
        //週次の場合、自由に1週間を設定できるようにする（日曜～土曜で固定しないため既存関数は使わない）
        // vuejs-datepickerが返すFormatを指定できないため、date()に統一

        //開始日
        datepickerStartDate: {
            get: function () { return this.startDate.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (date > this.stopDate) {
                    this.stopDate = this.$dayjs(date).startOf(this.dateUnit);
                }

                //週次の場合
                if (this.dateUnit == 'week') {
                    //開始日に選択された日付セット
                    this.startDate = this.$dayjs(date).startOf('day');

                    //終了日に開始日の1週間後をセット
                    this.stopDate = this.$dayjs(this.startDate).endOf('date').add(6, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.stopDate = (this.stopDate < yesterday) ? this.stopDate : yesterday;
                }

                //日次・月次
                else {
                    this.startDate = this.$dayjs(date).startOf(this.dateUnit);
                }
            },
        },


        //終了日
        datepickerStopDate: {
            get: function () { return this.stopDate.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (this.startDate > date) {
                    date = this.startDate;
                }

                //週次の場合
                if (this.dateUnit == 'week') {
                    //開始日と終了日の日数差を取得
                    const diff = this.$dayjs(date).diff(this.$dayjs(this.startDate));

                    //何週間空いているかに変換
                    const weeks = Math.floor(this.$dayjs.duration(diff).asWeeks());

                    //開始日のweeks週間後をセット
                    const addDay = 7 * (weeks + 1) - 1;
                    this.stopDate = this.$dayjs(this.startDate).endOf('date').add(addDay, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.stopDate = (this.stopDate < yesterday) ? this.stopDate : yesterday;
                }

                //日次・月次
                else {
                    this.stopDate = this.$dayjs(date).endOf(this.dateUnit);
                }
            },
        },

        inputSelectedTarget: {
            get: function () { return this.selectedTarget; },
            set: function (selectedTarget) {
                this.selectedTarget = selectedTarget;
            },
        },
        selectedTargetName: function () {
            const typeName = (() => {
                switch (this.selectedTarget.type) {
                    case 'single':
                        return '単品';
                    case 'totalling':
                        return 'グループ';
                    default:
                        return '';
                }
            })();
            const targetName = (() => {
                switch (this.selectedTarget.type) {
                    case 'single':
                        return '【' + this.selectedTarget.product.id + '】' + this.selectedTarget.product.name;
                    case 'totalling': {
                        const name = this.selectedTarget.totallingTarget.name ?? "";
                        const len = this.selectedTarget.totallingTarget.products?.length ?? 0;
                        return name + ` (${len}商品)`;
                    }
                    default:
                        return '';
                }
            })() ?? '';
            // 全商品の場合
            if (this.selectedTarget.type == 'single' && this.selectedTarget.product.id === -1) {
                return this.selectedTarget.product.name;
            }
            return `${typeName}：${targetName}`;
        },

        //サービス（店舗）選択
        inputSelectedService: {
            get: function () { return this.selectedService; },
            set: function (selectedService) {
                this.selectedService = selectedService;
            },
        },
        selectedServiceName: function () {
            return this.selectedService.name;
        },
        ...mapGetters({
            services: 'services/allByGroup',
        }),
    },
}
</script>

<style scoped lang="sass">
.pc
    display: none
.containerInner
    // gridのほうが順番管理しやすい
    // .dispMenu { order: 6 } で順番変更
    display: flex
    flex-direction: column
    padding-bottom: 10px
    min-height: 700px
.dispType
    font-size: 1.3rem
    display: flex
    justify-content: flex-end
    margin: 20px 10px 0 0
    .typeItem
        background: $whiteColor
        cursor: pointer
        margin-right: 8px
        text-align: center
        width: 110px
        .onDisp
            background: $mainColor
            color: $whiteColor
            padding: 3px
        .offDisp
            color: #c0c0c0
            padding: 3px
        &:hover
            opacity: .6
        .totallingMenu
            padding: 6px
    .roasDefault
        width: 20px
        height: 22px
        line-height: 22px
        font-size: 16px
        cursor: pointer
        opacity: .5
        &:hover
            transform: scale(1.6)
            opacity: 1
    .roasDefaultItem
        color: #ff9e00
        opacity: 1
.tooltips
    visibility: hidden
    opacity: 0
    position: absolute
    top: 15px
    z-index: 999
    padding: 10px
    background-color: $whiteColor
    border-radius: 5px
    box-shadow: 3px 3px 2px rgba(0, 0, 0, .5)
    color: $grayColor
    font-size: 1.2rem
    font-weight: normal
    transition: .3s
    line-height: 1.5
.tooltipsHover
    &:hover .tooltips
        visibility: visible
        opacity: 1
        transition: .3s
.ml20
    margin-left: 20px
.w10
    width: 10%
.dataControllLeft
    display: flex
    align-items: center
    gap: 10px
.modal_dataUpdate
    padding: 16px 32px
    color: $grayColor
    .header
        padding: 5px
        height: 50px
        margin-bottom: 5px
        h3
            display: block
            float: left
            font-size: 20px
    .dataUpdate_period
        display: flex
        flex-direction: column
        align-items: flex-start
        gap: 8px
        margin-bottom: 16px
        .dataUpdate_periodLabel
            font-size: 1.4rem
        .dispPeriod
            display: flex
            align-items: center
            gap: 5px
    p
        font-size: 1.6rem
    .updateBtn
        width: 100px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .dataUpdate_btns
        margin-top: 40px
        display: flex
        justify-content: space-evenly
.dispMenu
    background: $grayColor
    color: $whiteColor
    display: flex
    font-size: 1.4rem
    margin: 10px 20px 0 20px
    padding: 10px
    .dispLeftMenu
        flex: 1 1 auto
        height: 30px
        .dispItem
            margin-right: 10px
        .dispDateUnit
            margin-right: 0
        span
            display: inline-block
            vertical-align: middle
            .dispPeriodInput
                display: inline-block
        .applyBtn
            padding-left:  16px
            padding-right: 16px
        .calcItems
            border-bottom: 2px solid $whiteColor
            margin: 0 10px
            padding: 7px 0 5px
            width: 120px
            .calcItem
                width: 40%
            .calcResult
                text-align: right
                width: 60%
    .dispRightMenu
        flex: 1 0 auto
        text-align: right
        .vs__dropdown-menu
            min-width: 120px !important
        span
            display: inline-block
            text-align: left
            vertical-align: middle
        .dispSettingItem
            margin: 0 10px 0 30px
        .dispSettings
            margin-right: 10px;
        .dispSettingItem2
            margin-right: 10px;
        .dispSettingItemRadio2
            margin-right: 10px;
        .dispAdMenu
            background: $mainColor
            color: $whiteColor
            cursor: pointer
            overflow: hidden
            padding: 7px
            position: relative
            width: 350px
            &::before
                background: $whiteColor
                top: 0
                content: ''
                height: 100%
                left: 0
                position: absolute
                transform: translate(0%, 100%)
                transition: all .3s ease-in-out
                width: 100%
            &::after
                background: $whiteColor
                content: ''
                height: 16px
                position: absolute
                right: 8px
                transform: rotate(45deg)
                transition: all .3s ease-in-out
                top: 6px
                width: 16px
            &:hover
                color: $grayColor
                &::before
                    transform: translate(0%, 0%)
                &::after
                    background: $grayColor
                    transform: rotate(225deg)
            .productName
                display: block
                position: relative
        .mr
            margin-right: 10px
        .dispAdMenu2
            background: $mainColor
            color: $whiteColor
            cursor: pointer
            overflow: hidden
            padding: 7px
            position: relative
            width: 180px
            &::before
                background: $whiteColor
                top: 0
                content: ''
                height: 100%
                left: 0
                position: absolute
                transform: translate(0%, 100%)
                transition: all .3s ease-in-out
                width: 100%
            &::after
                background: $whiteColor
                content: ''
                height: 16px
                position: absolute
                right: 8px
                transform: rotate(45deg)
                transition: all .3s ease-in-out
                top: 6px
                width: 16px
            &:hover
                color: $grayColor
                &::before
                    transform: translate(0%, 0%)
                &::after
                    background: $grayColor
                    transform: rotate(225deg)
            .productName
                display: block
                position: relative
.dispMenu_white
    display: flex
    font-size: 1.4rem
    margin-left: 20px
    .dispLeftMenu
        margin-top: 10px
        flex: 1 1 auto
    .dispRightMenu
        flex: 1 0 auto
        text-align: right
.balloon
    display: flex
    a
        height: 30px
    .balloon_area
        position: relative
        width: 100%
    .input-balloon
        z-index: 4
        min-width: 880px
        max-width: 1100px
        margin-left: 20px
        position: absolute
        left: 0px
        top: 0px
        padding: 20px
        background: #fff
        border: 1px solid $mainColor
        &::before
            content: ''
            position: absolute
            left: -16px
            top: 15px
            display: block
            width: 0
            height: 0
            border-left: 16px solid transparent
            border-top: 16px solid $mainColor
        &::after
            content: ""
            position: absolute
            left: -14px
            top: 16px
            display: block
            width: 0
            height: 0
            border-left: 15px solid transparent
            border-top: 15px solid white
        p
            color: $mainColor
        .balloon_flex
            display: flex
            justify-content: space-between
            margin-bottom: 10px
        .square_btn
            display: block
            position: relative
            width: 30px
            height: 30px
            background: $mainColor
            margin-top: -10px
            cursor: pointer
            &::before
                content: ""
                position: absolute
                top: 50%
                left: 50%
                width: 2px
                height: 15px
                background: #fff
                transform: translate(-50%,-50%) rotate(45deg)
            &::after
                content: ""
                position: absolute
                top: 50%
                left: 50%
                width: 2px
                height: 15px
                background: #fff
                transform: translate(-50%,-50%) rotate(-45deg)
.dataControllBtn
    margin: 10px 20px 0 20px
    display: flex
    justify-content: flex-end
    gap: 4px
    .notSelected
        background: #ccc
        border-color: #ccc
        pointer-events: none
.dataControllBtnLeft
    display: flex
    justify-content: flex-start
    gap: 4px
.dispLoading
    margin: 0 20px 0 20px
    transform: translateY(10px)
    z-index: 5
.dispDataContents
    flex-shrink: 0
    font-size: 1.4rem
    margin: 10px 20px 0 20px
    max-height: 520px
    overflow: scroll
    overscroll-behavior: none
    &::-webkit-scrollbar
        height: 12px
        width: 4px
        border-radius: 2px
        background-color: #c0c0c0
    &::-webkit-scrollbar-thumb
        border-radius: 2px
        background-color: $mainColor
.errorMsgContents
    align-items: center
    display: flex
    font-size: 1.8rem
    height: 50%
    justify-content: center
    margin: 10px 20px 0 20px
.loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000

@include sp()
    .sp
        display: none !important
    .pc
        display: block !important
    .dispType
        justify-content: space-between
        margin: 20px 5px 0
        .typeItem
            width: 33%
        .typeItem:last-child
            margin-right: 0
    .dispMenu
        display: block
        margin: 10px 5px 0;
        font-size: 12px
        .applyBtn
            width: 60px
            padding: 5px 0
        .dispAdMenu
            width: 100% !important
            max-width: 240px
            margin-top: 10px
            &::after
                height: 10px !important
                top: 8px !important
                width: 10px !important
        .dispAdMenu2
            width: 100% !important
            max-width: 240px
            margin-top: 10px
            &::after
                height: 10px !important
                top: 8px !important
                width: 10px !important
        .dispSettings
            width: 100% !important
            max-width: 200px
            margin-top: 10px
        .dispRightMenu
            text-align: left
            .dispSettingMenu
                display: flex
                align-items: center
                .dispSettingItemSelect
                    width: 50%
                    max-width: 240px
                    .v-select
                        width: 100%
                .dispSettingItemRadio
                    margin-left: 2%
    .dispDataContents
        margin: 10px 5px 0;
</style>
